import React, { useState,useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MineralIntro = ({
  subheading,
  heading,
  desc,
  img,
  mineral,
  videoUrl,
  showEnquireBtn = true,
  showContactBtn = true
}) => {

  const [showPopup, setShowPopup] =
    useState(false);

    const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  country: "",
  quantity: "",
  company: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();
  console.count("Mineral enquiry submitted");

  if (!formData.name)
    return toast.error("Please enter name");

  if (!formData.phone)
    return toast.error("Please enter phone number");

  if (!formData.email)
    return toast.error("Please enter email");

  if (!formData.message)
    return toast.error("Please enter message");
  
  setLoading(true);

  try {

  const template = `
<div
style="
margin:0;
padding:40px 0;
background:#F6F4F0;
font-family:Georgia,'Times New Roman',serif;
"
>

<table width="100%" cellpadding="0" cellspacing="0">
<tr>
<td align="center">

<table
width="720"
cellpadding="0"
cellspacing="0"
style="
background:#ffffff;
border-radius:18px;
overflow:hidden;
box-shadow:0 15px 45px rgba(0,0,0,0.08);
"
>

<!-- TOP BAR -->

<tr>
<td
style="
height:8px;
background:#88664D;
"
></td>
</tr>

<!-- HEADER -->

<tr>
<td
style="
padding:50px 40px;
text-align:center;
background:#FAF8F5;
"
>

<!-- LOGO -->

<!--
<img
src='https://your-domain.com/logo.png'
alt='Iris Impulse India Pvt. Ltd. Logo'
style='max-width:180px;margin-bottom:20px;'
/>
-->

<div
style="
letter-spacing:3px;
text-transform:uppercase;
font-size:13px;
color:#88664D;
margin-bottom:10px;
"
>
Iris Impulse Pvt. Ltd.
</div>

<h1
style="
margin:0;
font-size:34px;
font-weight:700;
color:#111111;
line-height:1.3;
"
>
New Mineral Enquiry
</h1>

<p
style="
margin-top:18px;
font-size:16px;
color:#666666;
line-height:1.8;
"
>
A new enquiry has been submitted through the website.
</p>

</td>
</tr>

<!-- PRODUCT -->

<tr>
<td style="padding:0 45px;">

<div
style="
background:#88664D;
padding:22px 30px;
border-radius:12px;
text-align:center;
"
>

<div
style="
font-size:12px;
letter-spacing:2px;
text-transform:uppercase;
color:#EDE5DF;
margin-bottom:8px;
"
>
Enquiry For
</div>

<div
style="
font-size:24px;
font-weight:700;
color:#ffffff;
"
>
${mineral?.emailTitle}
</div>

</div>

</td>
</tr>

<!-- DETAILS -->

<tr>
<td style="padding:40px 45px;">

<h2
style="
margin:0 0 20px;
font-size:24px;
color:#111111;
border-bottom:2px solid #88664D;
padding-bottom:10px;
"
>
Customer Information
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE3DC;
border-radius:14px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Full Name</span><br/>
<strong>${formData.name}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Email Address</span><br/>
<strong>${formData.email}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Phone Number</span><br/>
<strong>${formData.phone}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;">
<span style="color:#777;">Country</span><br/>
<strong>${formData.country}</strong>
</td>
</tr>

</table>

<!-- BUSINESS DETAILS -->

<h2
style="
margin:40px 0 20px;
font-size:24px;
color:#111111;
border-bottom:2px solid #88664D;
padding-bottom:10px;
"
>
Business Requirements
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #EAE3DC;
border-radius:14px;
overflow:hidden;
"
>

<tr>
<td style="padding:18px 24px;border-bottom:1px solid #EAE3DC;">
<span style="color:#777;">Company Name</span><br/>
<strong>${formData.company}</strong>
</td>
</tr>

<tr>
<td style="padding:18px 24px;">
<span style="color:#777;">Required Quantity</span><br/>
<strong>${formData.quantity}</strong>
</td>
</tr>

</table>

<!-- MESSAGE -->

<div style="margin-top:40px;">

<h2
style="
margin:0 0 20px;
font-size:24px;
color:#111111;
"
>
Enquiry Message
</h2>

<div
style="
background:#FAF8F5;
border:1px solid #EAE3DC;
padding:25px;
border-radius:14px;
color:#444444;
line-height:1.9;
font-size:15px;
"
>
${formData.message}
</div>

</div>

</td>
</tr>

<!-- FOOTER -->

<tr>
<td
style="
background:#111111;
padding:35px;
text-align:center;
"
>

<div
style="
font-size:18px;
font-weight:700;
color:#ffffff;
margin-bottom:8px;
"
>
Iris Impulse India Pvt. Ltd.
</div>

</td>
</tr>

</table>

</td>
</tr>
</table>

</div>
`;

    const data = new FormData();

    data.append(
      "title",
      " Iris Mineral Enquiry Form"
    );

    data.append(
      "to_email",
      "rajan@irisimpulse.com"
    );

     data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      `Enquiry for ${mineral?.emailTitle}`
    );

    data.append(
      "template",
      template
    );

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    toast.success(
      "Enquiry submitted successfully"
    );

    setFormData({
      name: "",
      phone: "",
      email: "",
      country: "",
      quantity: "",
      company: "",
      message: "",
    });

    setShowPopup(false);

  } catch (error) {

    toast.error(
      "Something went wrong"
    );

  } finally {

    setLoading(false);

  }
};

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: "easeOut"
      }
    }
  };

useEffect(() => {

  if (showPopup) {
    document.body.classList.add(
      "popup-open"
    );
  } else {
    document.body.classList.remove(
      "popup-open"
    );
  }
  return () => {
    document.body.classList.remove(
      "popup-open"
    );
  };

}, [showPopup]);

  return(
    <>
      <section className="bentonite-intro-cards">
         <ToastContainer
  position="top-right"
  autoClose={3000}
/>

        <div className="container">

          <motion.div
            className="bentonite-intro-card"
            initial={{
              opacity: 0,
              scale: 0.98
            }}
            whileInView={{
              opacity: 1,
              scale: 1
            }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
        
{/* IMAGE / VIDEO */}
<div
  className={`bentonite-intro-img ${
    videoUrl ? "intro-video-wrapper" : ""
  }`}
>
  {videoUrl ? (
    <iframe
      src={videoUrl}
      title={`${heading} | Iris Impulse India Pvt. Ltd.`}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
      loading="lazy"
    />
  ) : (
    <motion.img
      src={img}
      alt={`${heading} | Iris Impulse India Pvt. Ltd.`}
      initial={{ scale: 1.05 }}
      whileInView={{ scale: 1 }}
      transition={{ duration: 1.2 }}
    />
  )}
</div>

            {/* CONTENT */}

            <motion.div
              className="bentonite-intro-content"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{
                opacity: 1,
                y: 0
              }}
              transition={{
                delay: 0.2,
                duration: 0.6
              }}
            >
              <div className="bentonite-intro-content-inner">
              {subheading && (
  <h3 className="section-subheading">
    {subheading}
  </h3>
)}

              <h2 className="section-heading">
                {heading}
              </h2>

              <p className="section-text">
                {desc}
              </p>

            {(showEnquireBtn || showContactBtn) && (

<motion.div
  className="btn-group"
  variants={fadeUp}
>

                {/* ENQUIRE BTN */}

                {showEnquireBtn && (

<motion.button
  className="black-btn"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.97 }}
  onClick={() =>
    setShowPopup(true)
  }
>
  ENQUIRE NOW
</motion.button>

)}

                {/* CONTACT BTN */}

              {showContactBtn && (

<motion.a
  href="/contact-us"
  className="outline-btn"
  whileHover={{ scale: 1.05 }}
  whileTap={{ scale: 0.97 }}
>
  GET IN TOUCH
</motion.a>

)}


            </motion.div>

)}
</div>

            </motion.div>

          </motion.div>

        </div>

      </section>

      {/* ===================================
          ENQUIRY POPUP
      =================================== */}

      <AnimatePresence>

        {showPopup && (

          <motion.div
            className="enquiry-popup-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() =>
              setShowPopup(false)
            }
          >

            <motion.div
              className="enquiry-popup"
              initial={{
                opacity: 0,
                y: 60,
                scale: 0.95
              }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1
              }}
              exit={{
                opacity: 0,
                y: 60,
                scale: 0.95
              }}
              transition={{
                duration: 0.35
              }}
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              {/* CLOSE */}

              <button
                className="enquiry-popup-close"
                onClick={() =>
                  setShowPopup(false)
                }
              >
                ×
              </button>

              {/* HEADING */}

              <h4 className="card-heading">

                Do an Enquiry for{" "}
                {mineral?.cardTitle}

              </h4>

              {/* FORM */}

           <form
  className="enquiry-form"
  onSubmit={handleSubmit}
>

                <input
  type="text"
  name="name"
  value={formData.name}
  onChange={handleChange}
  placeholder="Name *"
/>

             
<input
  type="tel"
  name="phone"
  value={formData.phone}
  onChange={handleChange}
  placeholder="Phone Number *"
/>


<input
  type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Email Address *"
/>

                <input
                  type="text"
                  placeholder="Country"
                  name="country"
                  value={formData.country}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  placeholder="Quantity"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  placeholder="Company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />

                <textarea
                  rows="5"
                  placeholder="Message *"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />

               <button
  type="submit"
  className="black-btn"
  disabled={loading}
>
  {loading
    ? "Submitting..."
    : "SUBMIT ENQUIRY"}
</button>

              </form>

            </motion.div>

          </motion.div>
        )}

      </AnimatePresence>
    </>
  )
}

export default MineralIntro;